module.exports = __webpack_public_path__ + "static/media/feed_the_ward_map_important.c76bcb2f.svg";